export const imgMapObjectStatuseslInit = () => {
  const imgMaps = document.querySelector('.img-map-apartments');
  const apartmentsList = document.querySelector('.apartments-list');

  
  if (!imgMaps || !apartmentsList || typeof ImageMapPro === "undefined") return;

  jQuery(document).on('ninja_table_loaded', function(e, table_id) {
    const updatePolygons = () => {
      const polygons = document.querySelectorAll('.imp-objects .imp-object');
      const rows = Array.from(document.querySelectorAll(".ninja_table_wrapper tbody tr"));

      polygons.forEach((polygon) => {
        const polygonId = polygon.getAttribute("data-title");
        const matchedRow = rows.find(row => {
          const idCell = row.querySelector(".ninja_clmn_nm_ID");
          return idCell && idCell.textContent.trim() === polygonId;
        });

        if (matchedRow) {
          const statusCell = matchedRow.querySelector(".ninja_clmn_nm_Status");
          if (statusCell) {
            const status = statusCell.textContent.trim().toLowerCase();
            polygon.classList.remove('property-available', 'property-reservation', 'property-sold');

            if (status === "dostępne") polygon.classList.add('property-available');
            else if (status === "rezerwacja") polygon.classList.add('property-reservation');
            else if (status === "sprzedane") polygon.classList.add('property-sold');
          }
        }
      });
    };

    if(imgMaps.classList.contains('img-map-apartments-single')) {
      updatePolygons();
    } else {
      if (!window.imageMapProSubscribed) {
        window.imageMapProSubscribed = true;

        ImageMapPro.subscribe((action) => {
          if (action.type === "artboardChange") {
            updatePolygons();
          }
        });
      }
    }
  });
}